import * as userRequest from "@/utils/userRequest";

export interface ImageDataType {
  key: string;
  base64: string;
}

export interface KYCServiceDataType {
  country_id: string;
  data_doc: {};
  type_id: string;
  images: ImageDataType[];
}

const checkKycService = async (
  token: string,
  onSuccess?: (data?: any) => any,
  handleError?: (err?: any) => any
) => {
  try {
    console.log("🚀 ~ checkKycService ~ token:", token);

    const response = await userRequest.get("kyc/get", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("🚀 ~ checkKycService ~ response:", response);

    if (response) {
      onSuccess && onSuccess(response);
      return response;
    }
  } catch (error) {
    console.error("🚀 ~ checkKycService ~ error:", error);
    if (handleError) {
      handleError(error);
    }
    throw error;
    // return null;
  }
};

export default checkKycService;